// extracted by mini-css-extract-plugin
export default {"rating":"TC-z","numberOfStars":"UC-z","count":"VC-z","barGraphSpacing":"WC-z","barGraph":"XC-z"};